import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/header.component';
import Asaid from '../../components/layout/asaid.component';
import Footer from '../../components/layout/footer.component';
import useBgPages from '../../hooks/use-bg-pages.hook';
import Icon from '../../components/forms/icon.component';

function DashboardPage() {
  useBgPages();
  const { t } = useTranslation();

  return (
    <>
      <div className="page d-flex flex-row flex-column-fluid">
        <Asaid />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <Header />
          <div className="content fs-6 d-flex flex-column flex-column-fluid" id="kt_content">
            <div className="toolbar" id="kt_toolbar">
              <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                  <ul className="breadcrumb fw-semibold fs-base my-1">
                    <li className="breadcrumb-item text-muted">{t('general.welcome')}</li>
                  </ul>
                  <h1 className="fw-bold fw-bold my-1 fs-2">
                    <span className="d-flex align-items-center">
                      <Icon icon="ki-abstract-25" size="fs-3x" type="dark" />
                      <span className="ms-3">{t('dashboard-page.title-page')}</span>
                    </span>
                  </h1>
                </div>
              </div>
            </div>
            <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
              <div className="d-flex flex-column flex-lg-row-fluid align-items-center justify-content-center py-10 bg-p-sdark">
                <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between p-5">
                  <div className="col-lg-6 text-center text-lg-start">
                    <h1 className="text-info fw-bolder mb-3 fs-3x animated-Alert">
                      {t('dashboard-page.comming-soon')}
                    </h1>
                    <h1 className="fw-bolder mb-3 fs-5x inputb text-dark">
                      {t('dashboard-page.title-page')}
                    </h1>
                    <p className="text-gray-500 fs-2 mb-10 inputb">
                      {t('dashboard-page.subtitle')}
                    </p>
                  </div>
                  <div className="col-lg-6 d-flex justify-content-cente animated-Alert">
                    <img
                      src="/assets/media/illustrations/undraw/chart-2.svg"
                      alt="Link caducado o no exite la url"
                      className="img-fluid  link-caducated"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default DashboardPage;
